import React from "react";

export default function Heading(props) {
  return (
    <div className="text-white font-sans font-bold text-2xl">{props.title}</div>
  );
}
